import {
  ACTIVE_DEPLOYED_ENV,
  DEPLOYMENT_ENV_TYPE_DEV,
  DEPLOYMENT_ENV_TYPE_PROD,
  DEPLOYMENT_ENV_TYPE_UAT,
  globalAdminUrl,
  RECOMMENDATION_PYTHON_DEV_API_BASE_URL,
  RECOMMENDATION_PYTHON_PROD_API_BASE_URL,
  RECOMMENDATION_PYTHON_UAT_API_BASE_URL
} from './globalApi';

export const CommonApiforJourney = async (method, endpoint, credentials, authToken, formType) => {
  try {
    const headerData = {};
    const requestBody = {};
    let basePath = '';
    if (formType === 'formdata') {
      headerData.Authorization = `Bearer ${authToken}`;
    } else {
      headerData['Content-Type'] = `application/json`;
      headerData.Authorization = `Bearer ${authToken}`;
    }

    if (method === 'GET') {
      requestBody.method = method;
      requestBody.headers = headerData;
    } else {
      requestBody.method = method;
      requestBody.headers = headerData;
      requestBody.body = credentials;
    }

    if (credentials === 'tokenNotRequired') {
      if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_PROD) {
        basePath = RECOMMENDATION_PYTHON_PROD_API_BASE_URL;
      } else if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_UAT) {
        basePath = RECOMMENDATION_PYTHON_UAT_API_BASE_URL;
      } else if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_DEV) {
        basePath = RECOMMENDATION_PYTHON_DEV_API_BASE_URL;
      }
    } else {
      basePath = globalAdminUrl;
    }

    return await fetch(`${basePath}/${endpoint}`, requestBody)
      .then((response) => {
        if (
          response.headers.get('content-type').includes('application/octet-stream') ||
          response.headers.get('content-type').includes('application/zip')
        ) {
          return response.blob();
        } else {
          return response.json();
        }
      })
      .then((res) => res);
  } catch (error) {
    return {
      msg: `Server not responding error ${error}`
    };
  }
};
